import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Calendar, dateFnsLocalizer, Event } from 'react-big-calendar';
import { useParams } from 'react-router-dom';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CustomCalendarToolbar from './CustomCalendarToolbar';
import './dlmCalendar.css';
import { Api } from 'api';

// Date-fns locales
const locales = {
  'en-US': require('date-fns/locale/en-US'),
};

// Localizer setup
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales,
});

const handleDragStart = () => {
  return;
};

const CustomEvent: React.FC<{ event: any }> = ({ event }) => {
  const [behaviourName, timeRange] = event.title.split(' (');
  return (
    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
      <span>{behaviourName}</span>
      <br />
      <span style={{ fontWeight: 600 }}>{timeRange ? timeRange.slice(0, -1) : ''}</span>
    </div>
  );
};

const DLMCalendar = observer(() => {
  const [events, setEvents] = useState<Event[]>([]);
  const { dlmid } = useParams<{ dlmid: string }>();

  const fetchPeriods = (date: Date) => {
    const fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    const toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    Api.charge
      .listDLMPeriodsForStrategy(dlmid, {
        skip: 0,
        take: 1000,
        sortBy: 'fromTime',
        sortOrder: 'ASC',
        fromDate: fromDate.toISOString().split('T')[0],
        toDate: toDate.toISOString().split('T')[0],
      })
      .then((response) => {
        const transformedEvents = response?.data?.data?.map((period: any) => {
          const startDate = new Date(period.specificDate);
          const [fromHour, fromMinute] = period.fromTime.substring(0, 5).split(':').map(Number);
          startDate.setHours(fromHour, fromMinute, 0, 0);

          const endDate = new Date(period.specificDate);
          const [toHour, toMinute] = period.toTime.substring(0, 5).split(':').map(Number);
          endDate.setHours(toHour, toMinute, 0, 0);

          const timeRange = `${period.fromTime.substring(0, 5)} - ${period.toTime.substring(0, 5)}`;
          return {
            title: `${period.behaviourName} (${timeRange})`,
            start: startDate,
            end: endDate,
            resource: period,
          };
        });
        setEvents(transformedEvents);
      });
  };

  useEffect(() => {
    fetchPeriods(new Date());
  }, []);

  return (
    <div className="dlm-calendar-container">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        popup
        views={['month']}
        components={{
          toolbar: CustomCalendarToolbar,
          event: CustomEvent,
        }}
        onSelectEvent={(event) => {
          console.log('Clicked event:', event.resource);
        }}
        onNavigate={(date) => {
          fetchPeriods(date);
        }}
        handleDragStart={handleDragStart}
      />
    </div>
  );
});

export default DLMCalendar;
